import {Inject, Pipe, PipeTransform} from '@angular/core';
import * as _ from "lodash";
import {TranslateService} from "@ngx-translate/core";
import {BringozVolumePipe} from "../../../commons/angular/pipes/bringoz-volume.pipe";

@Pipe({
  standalone: false,
  name: 'planningPackagesVolumePipe'
})
export class PlanningPackagesVolumePipe implements PipeTransform {

  constructor(
    @Inject(TranslateService) private translateService: TranslateService,
    @Inject(BringozVolumePipe) private bringozVolumePipe: BringozVolumePipe
  ) {}

  transform(packages, enableUnitDisplay?: boolean, defaultValue: string = '--'): string {
    const itemsVolumeSum = _.reduce(packages, (sum, packageRef) => {
      const volume = (_.get(packageRef, 'volume') || _.get(packageRef, 'dimensions.cube'));
      if (!volume) {
        return sum;
      }
      return sum + volume;
    }, 0);

    return itemsVolumeSum ? this.bringozVolumePipe.transform(itemsVolumeSum, enableUnitDisplay) : defaultValue;
  }

}
